import React from 'react';
import { useScreenSize } from '../../../helpers';

const ProImage = ({ src, srcMobile, srcTablet, alt = '', role = 'presentation', className }) => {
    const { isMobileScreen } = useScreenSize();
    return (
        <picture id="pro-image">
            {isMobileScreen && srcMobile && <source media="(max-width: 768px)" srcSet={srcMobile} />}
            <img src={src} alt={alt} role={role} className={className} />
        </picture>
    );
};

export default ProImage;
